import React, { useEffect, useState } from 'react';
import { formSubmit } from '../../../datafetchers/IVFPage';
import { getCountryOnBasisOfUrl } from '../../../Utils/ForeignUtils';
import { validationHandler } from '../../Clinic/HealthPlan/common';
import { GeneralFormContainer } from '../../Clinic/HealthPlan/styled';
import SuccessHealthPopup from '../../Clinic/HealthPlan/SuccessPopup';
import { CssLoader } from '../../StoreHomePage/AddToCartButton/styled';
import FormFields from '../formField';
import { BookNowCtabtn } from '../styled';

export default function FormComponent(props) {
  const { data, ctaButtonText, skuId, skuName, formSuccessData } = props;
  const formData = data?.form;
  const leadsDataString = 'leadsData';
  const [showLoader, setShowLoader] = useState(false);
  const [questions, setQuestions] = useState(data?.questions);
  const [formResponse, setFormResponse] = useState([]);

  const inputFieldErrorHandler = (value, index) => {
    let e = value?.trim();
    questions?.map((element, i) => {
      if (index == i) {
        element['answer_text'] = e;
      }
    });
    setQuestions(questions);
  };
  const country_code = getCountryOnBasisOfUrl();
  const SubmitHandler = async (event) => {
    setShowLoader(true);
    event?.preventDefault();
    questions?.map((element, i) => {
      if (
        !validationHandler(element?.validation_type, element['answer_text']) ||
        element['answer_text']?.length == 0
      ) {
        return true;
      }
    });

    let payload = {
      form_id: formData?.id,
      sku_id: skuId,
      sku_name: skuName,
      form_response: questions,
    };
    const ApiResponse = await formSubmit(payload, '', country_code);
    if (ApiResponse?.success) {
      setShowLoader(false);
      setFormResponse(questions);
      localStorage.setItem(leadsDataString, JSON.stringify(questions));
    }
  };
  useEffect(() => {
    setFormResponse(JSON.parse(localStorage.getItem(leadsDataString)));
  }, []);

  return (
    <>
      <GeneralFormContainer>
        {formResponse?.length ? (
          <SuccessHealthPopup
            formResponse={formResponse}
            formSuccessData={formSuccessData}
            setFormResponse={setFormResponse}
            leadsDataString={leadsDataString}
          />
        ) : (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              SubmitHandler(e);
            }}
          >
            <FormFields
              inputFieldErrorHandler={inputFieldErrorHandler}
              questions={questions}
            />

            <BookNowCtabtn disabled={false} generalForm>
              {showLoader ? (
                <CssLoader
                  className={'loaded'}
                  theme="#fff"
                  aplusplus
                ></CssLoader>
              ) : ctaButtonText ? (
                ctaButtonText
              ) : (
                'Confirm Booking'
              )}
            </BookNowCtabtn>
          </form>
        )}
      </GeneralFormContainer>
    </>
  );
}
